import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  load: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: theme.spacing(40),
    minWidth: theme.spacing(105),
  },
}));
